<template>
	<section class="page">
		<el-tabs v-model="activeName" v-loading="loadings.dm">
			<el-tab-pane label="订单" name="order">
				<order v-if="activeName=='order'" :record-id="id" class="content-box"></order>
			</el-tab-pane>
			<el-tab-pane label="库存" name="info">
				<product-base-stock v-if="activeName=='info'" :record-id="id" :value="info" class="content-box"></product-base-stock>
			</el-tab-pane>
			<el-tab-pane label="出入库历史" name="inbound">
				<product-tx-inbound
					v-if="activeName=='inbound'"
					:dataModel="dataModel"
					:record-id="id"
					class="content-box"
					@change="handleEdited($event)"
					:table-data-model="dataModels[dataModel]"
					:has-get-table-data-model="hasGetTableDataModel"
					:value="info"
				></product-tx-inbound>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import ProductBaseStock from "@/views/Setting/subs/ProductBaseStock.vue";
import ProductTxInbound from "@/views/Setting/subs/ProductTxInbound.vue";
import Order from "@/views/Setting/Order.vue"
import { mapState, mapGetters, mapMutations } from "vuex";
import TabPage from "@/mixins/TabPage.js";
import LoadDM from "@/mixins/LoadDM.js";

export default {
	mixins: [TabPage, LoadDM],
	components: {
		ProductBaseStock,
		ProductTxInbound,
		Order
	},
	data() {
		return {
			loadings: {
				main: false,
				dm: false,
				create: false
			},
			activeName: "order",
			hasLoadData: false,
			dataModel: "Product_color",
			info: {},
			styles: [],
			visible: false,
			id: ""
		};
	},
	computed: {},
	created() {},
	mounted() {
		this.refreshData();
	},
	methods: {
		...mapMutations(["checkDataModel"]),
		refreshData() {
			this.id = this.$route.params.id;
			this.loadings.main = true;

			this.$axios
				.post(`/curd/edit/${this.dataModel}/${this.id}`)
				.then(json => {
					this.loadings.main = false;
					for (let k in json.data.info) {
						this.$set(this.info, k, json.data.info[k]);
					}
					this.hasLoadData = true;
				})
				.catch(json => {
					this.loadings.main = false;
				});
		},
		handleEdited(value) {
			for (let k in value) {
				this.$set(this.info, k, value[k]);
			}
		}
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: "refreshData"
	}
};
</script>
<style lang="scss" scoped>
</style>
